module.exports = __webpack_public_path__ + "static/media/experience-unique-homes.6ca8ecb9.jpg";